import { JsonLd } from 'components/common/JsonLd';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import type { Faqs } from 'types/cms/blocks/Faqs';
import type { PageModule } from 'types/cms/PageModule';
import { buildFaqPage, faqBlockId, type FaqPageSchema } from 'utils/jsonld';

interface FaqsJsonLdProps {
  blocks: PageModule[];
}

// Emits a single FAQPage script merging every embedded timeline_faq
// block on the page. Done here (not inside FaqsBlock) so multiple FAQ
// blocks on one page collapse into one schema with one @id rather
// than conflicting copies.
export function FaqsJsonLd({ blocks }: FaqsJsonLdProps) {
  const router = useRouter();

  const schema = useMemo<FaqPageSchema | null>(() => {
    const faqBlocks = blocks.filter(
      (block): block is Faqs => block._type === 'timeline_faq',
    );
    return buildFaqPage({
      entries: faqBlocks.flatMap((block) => block.list),
      pagePath: router.asPath,
      variant: 'block',
    });
  }, [blocks, router.asPath]);

  if (!schema) return null;
  return <JsonLd scriptKey={faqBlockId(router.asPath)} schema={schema} />;
}
